var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5547,
    cy: 28.1445,
    r: 26.5,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9325_1512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0982 41.3693H14.0547V23.1738H21.0982V41.3693ZM15.2285 40.1955H19.9243V24.3477H15.2285V40.1955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.055 41.3693H34.0115V31.3912C34.0115 30.4187 33.2231 29.6303 32.2506 29.6303C31.278 29.6303 30.4898 30.4187 30.4898 31.3912V41.3693H23.4463V23.1738H30.4898V24.355C31.5529 23.5863 32.8316 23.173 34.1435 23.1738C37.9513 23.1738 41.055 26.2627 41.055 30.0632V41.3693ZM35.1853 40.1955H39.8809V30.0632C39.873 26.9013 37.3054 24.3436 34.1435 24.3477C32.6982 24.3477 31.3408 24.9566 30.3283 26.0572L29.3157 27.165V24.3477H24.6201V40.1955H29.3157V31.3912C29.3157 29.7702 30.6297 28.4564 32.2506 28.4564C33.8714 28.4564 35.1853 29.7702 35.1853 31.3912V40.1955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5764 21.9995C15.6313 21.9995 14.0547 20.4229 14.0547 18.4778C14.0547 16.5329 15.6313 14.9561 17.5764 14.9561C19.5215 14.9561 21.0982 16.5329 21.0982 18.4778C21.0941 20.4212 19.5198 21.9957 17.5764 21.9995ZM17.5764 16.1301C16.2798 16.1301 15.2285 17.1812 15.2285 18.4778C15.2285 19.7746 16.2798 20.8257 17.5764 20.8257C18.873 20.8257 19.9243 19.7746 19.9243 18.4778C19.9243 17.1812 18.873 16.1301 17.5764 16.1301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9325_1512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(14.0547 14.6445)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.718304959486354fb2edebd34ad6855e.svg";
export { ForwardRef as ReactComponent };